import React from 'react';

export default function ServiceUserSocialWorkerModule({ serviceUser, onClose }) {
    const swData = serviceUser.socialWorker || {};

    const Field = ({ label, value }) => (
        <div style={{ marginBottom: '15px', minWidth: '200px', flex: '1' }}>
            <label style={{ display: 'block', fontSize: '12px', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px', fontWeight: 'bold' }}>{label}</label>
            <div style={{ fontSize: '15px', fontWeight: '500', color: '#111827' }}>{value || 'Not provided'}</div>
        </div>
    );

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#111827' }}>Social Worker</h2>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>Social care contact for {serviceUser.fullName}</p>
                    </div>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>
                
                <div style={styles.scrollArea}>
                    <div style={styles.section}>
                        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '16px', color: '#374151', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px' }}>Personal Details</h3>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Name" value={swData.name} />
                            <Field label="Phone" value={swData.phone} />
                            <Field label="Email Address" value={swData.email} />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                            <Field label="Address" value={swData.address} />
                            <Field label="Start Date" value={swData.startDate} />
                        </div>
                    </div>

                    <div style={{...styles.section, marginTop: '20px'}}>
                        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '16px', color: '#374151', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px' }}>Organisation</h3>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Organisation Name" value={swData.organisation} />
                            <Field label="Organisation ID" value={swData.idCode} />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                            <Field label="Organisation Address" value={swData.organisationAddress} />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                            <Field label="Responsibilities" value={swData.responsibilities} />
                        </div>
                    </div>

                    <div style={{...styles.section, marginTop: '20px'}}>
                        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '16px', color: '#374151', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px' }}>Emergency Contact</h3>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Emergency Name" value={swData.emergencyName} />
                            <Field label="Emergency Number" value={swData.emergencyContact} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent: { backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' },
    modalHeader: { padding: '24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: '#9ca3af', cursor: 'pointer', lineHeight: 1 },
    scrollArea: { padding: '24px', overflowY: 'auto' },
    section: { backgroundColor: '#f9fafb', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb' }
};
